<div class="default-breadcrumb-header-main">
  <!-- TODO put text-transform: initial; here inside some <span> tag -->
  <core-title-section [title]="title" [breadcrumbs]="breadcrumbs"></core-title-section>
  <div class="labels-container"><core-labels-text [labels]="labels"></core-labels-text></div>
  <core-helpers-navigation-three-dots-menu [menu]="menu" (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>
</div>
